module.exports = __webpack_public_path__ + "static/media/IntroScorecard.9c2af947.svg";